import React, {useState, useEffect} from 'react'
import Select from 'react-select'

function SelectPermissions(props) {

    const data = [
        {
            name: "Lector",
            id: "R"
        },
        {
            name: "Editor",
            id: "E"
        }
    ];

    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    
    const formatData = () => {
        let newList = [];
        for(var i=0; i < data.length; i++){
            let thisElement = data[i];
            let formattedElement = {};
            formattedElement.label = thisElement.name;
            formattedElement.value = thisElement.id;

            newList.push(formattedElement);
        }            

        setList(newList);
        setLoading(false);
    }

    useEffect(() => {
        if(loading){
            if(data !== null) {
                formatData();
            }
        }
    });

    const handleSelect = async (selectedOption) => {
        //console.log(selectedOption);
        //props.setRegion({});
        //props.setCity({});
        //console.log(selectedOption);
        props.onChange(selectedOption); 
    };

    if(loading){
        return (
            <Select 
                placeholder="Cargando.."  
                options={[]} 
            />
        )
    }else{


        let elementSelected = null;

        if(props.value !== undefined && props.value !== null && list.length > 0){
            let findElement = list.find(item => item.value === props.value);
            elementSelected = findElement;
            //console.log(elementSelected);
        }

        return (
            <Select 
                isSearchable={false}
                classNamePrefix={props.normal !== undefined ? "" : "react-dropdown"}
                styles={{
                    // Fixes the overlapping problem of the component
                    menu: provided => ({ ...provided, zIndex: 9999 })
                }}
                placeholder="Permiso" 
                value={(props.value !== undefined && props.value !== null && list.length > 0) ? elementSelected : null} 
                onChange={handleSelect} 
                options={list} 
            />
        )
    }
}

export default SelectPermissions
